import React from "react";
import { CpColorPicker } from "@components";

/**
 * Legacy CprColorpicker component - now a wrapper around the modern CpColorPicker.
 *
 * This maintains backward compatibility with the custom element events pattern
 * while using the modern component implementation internally.
 *
 * @deprecated Use CpColorPicker directly for new implementations
 *
 * Legacy API:
 * - Props: color, format, monochromatic, events
 * - Events: events.colorchange({ detail: colorString })
 *           events.lightnesschange({ detail: lightnessNumber })
 *
 * Modern API (CpColorPicker):
 * - Props: color, format, monochromatic, onColorChange, onLightnessChange
 * - Callbacks: onColorChange(colorString), onLightnessChange(lightnessNumber)
 */
export class CprColorpicker extends React.Component {
  render() {
    const { color, format, monochromatic, events } = this.props;

    return (
      <CpColorPicker
        color={color}
        format={format}
        monochromatic={monochromatic}
        onColorChange={
          events?.colorchange
            ? (colorValue) => {
                // Wrap the color value in the legacy event structure
                events.colorchange({ detail: colorValue });
              }
            : undefined
        }
        onLightnessChange={
          events?.lightnesschange
            ? (lightnessValue) => {
                // Wrap the lightness value in the legacy event structure
                events.lightnesschange({ detail: lightnessValue });
              }
            : undefined
        }
      />
    );
  }
}
